<template>
  <div class="about">
    <v-container fluid class="py-0">
      <v-row>
        <v-col cols="12" class="py-0 px-0">
          <div class="wrap">
            <div>
              <v-img
                :src="'https://www.mlcpcms.actstudio.xyz/'+aboutSingleton.cover.path"
                class="intro-img"
              ></v-img>
            </div>

            <div class="overlay">
              <div class="text-overlay">
                <span class="titles">{{aboutSingleton.title}}</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- section desk w-->
      <div class="d-none d-lg-block">
        <v-container>
          <v-row class="mt-1 mt-md-11" justify="space-between">
            <v-col cols="12" md="6" class="py-4 py-md-0">
              <span class="title-about bold" v-html="aboutSingleton.description_1.subtitle"></span>

              <hr class="d-block hr-about mt-2" />

              <div
                class="mt-2 maxWidth-Three texts"
                id="paragraphs"
                v-html="aboutSingleton.description_1.description"
              >
                <!-- <p>
                  <span>{{contentRow1.p1}}</span>
                </p>

                <p>
                  <span>{{contentRow1.p2}}</span>
                </p>

                <p>
                  <span>{{contentRow1.p3}}</span>
                </p>-->
              </div>
            </v-col>

            <v-col cols="12" md="6" class="py-0 padding-left-about">
              <v-img
                :src="'https://www.mlcpcms.actstudio.xyz/'+aboutSingleton.cover_description_1.path"
                class="about-img"
              ></v-img>
            </v-col>
          </v-row>

          <!-- *************Objetivo*************** -->
          <v-row class="mt-2 mt-md-12">
            <v-col cols="12" md="6" class="py-0">
              <v-img
                :src="'https://www.mlcpcms.actstudio.xyz/'+aboutSingleton.cover_description_2.path"
                class="about-img"
              ></v-img>
            </v-col>

            <v-col cols="12" md="6" class="py-4 py-md-0 padding-left-about">
              <span class="title-about bold" v-html="aboutSingleton.description_2.subtitle"></span>

              <hr class="d-block hr-about mt-2" />

              <div
                class="mt-2 maxWidth-Three texts"
                id="paragraphs"
                v-html="aboutSingleton.description_2.description"
              ></div>
            </v-col>
          </v-row>
          <!-- *************/Objetivo************** -->

          <!-- ************Misión y valores******** -->
          <v-row class="mt-2 mt-md-12">
            <v-col cols="12" md="6" class="py-4 py-md-0">
              <span class="title-about bold">{{aboutSingleton.description_3.subtitle}}</span>

              <hr class="d-block hr-about mt-2" />

              <div
                class="mt-2 maxWidth-Three texts"
                id="paragraphs"
                v-html="aboutSingleton.description_3.description"
              ></div>
            </v-col>

            <v-col cols="12" md="6" class="py-0 padding-left-about">
              <v-img
                :src="'https://www.mlcpcms.actstudio.xyz/'+aboutSingleton.cover_description_3.path"
                class="about-img"
              ></v-img>
            </v-col>
          </v-row>
          <!-- ************/Misión y valores******* -->

          <!-- ***********Nuestro equipo*********** -->
          <v-row class="mb-md-12 mt-2 mt-md-12">
            <v-col cols="12" md="6" class="py-0">
              <v-img
                :src="'https://www.mlcpcms.actstudio.xyz/'+aboutSingleton.cover_description_4.path"
                class="about-img"
              ></v-img>
            </v-col>

            <v-col cols="12" md="6" class="py-4 py-md-0 padding-left-about">
              <span class="title-about bold">{{aboutSingleton.description_4.subtitle}}</span>

              <hr class="d-block hr-about mt-2" />

              <div
                class="mt-2 maxWidth-Three texts"
                id="paragraphs"
                v-html="aboutSingleton.description_4.description"
              ></div>
            </v-col>
          </v-row>
          <!-- ***********/Nuestro equipo********** -->
        </v-container>
      </div>
      <!-- section desk -->

      <!-- section mobile-->
      <div class="d-lg-none">
        <v-row class="mt-1 mt-md-11" justify="space-between">
          <v-col cols="12" md="6" class="px-6 py-4 py-md-0 px-md-10">
            <span class="title-about bold">{{aboutSingleton.description_1.subtitle}}</span>

            <hr class="d-block hr-about mt-2" />

            <div
              class="mt-2 maxWidth-Three texts"
              id="paragraphs"
              v-html="aboutSingleton.description_1.description"
            ></div>
          </v-col>

          <v-col cols="12" md="6" class="px-0 py-0 px-md-10">
            <v-img
              :src="'https://www.mlcpcms.actstudio.xyz/'+aboutSingleton.cover_description_1.path"
              class="about-img"
            ></v-img>
          </v-col>
        </v-row>

        <!-- *************Objetivo*************** -->
        <v-row class="mt-2 mt-md-12">
          <v-col cols="12" md="6" class="px-0 py-0 px-md-10" order="1" order-md="0">
            <v-img
              :src="'https://www.mlcpcms.actstudio.xyz/'+aboutSingleton.cover_description_2.path"
              class="about-img"
            ></v-img>
          </v-col>

          <v-col cols="12" md="6" class="px-6 py-4 py-md-0 px-md-10" order="0" order-md="1">
            <span class="title-about bold">{{aboutSingleton.description_2.subtitle}}</span>

            <hr class="d-block hr-about mt-2" />

            <div
              class="mt-2 maxWidth-Three texts"
              id="paragraphs"
              v-html="aboutSingleton.description_2.description"
            ></div>
          </v-col>
        </v-row>
        <!-- *************/Objetivo************** -->

        <!-- ************Misión y valores******** -->
        <v-row class="mt-2 mt-md-12">
          <v-col cols="12" md="6" class="px-6 py-4 py-md-0 px-md-10">
            <span class="title-about bold">{{aboutSingleton.description_3.subtitle}}</span>

            <hr class="d-block hr-about mt-2" />

            <div
              class="mt-2 maxWidth-Three texts"
              id="paragraphs"
              v-html="aboutSingleton.description_3.description"
            ></div>
          </v-col>

          <v-col cols="12" md="6" class="px-0 py-0 px-md-10">
            <v-img
              :src="'https://www.mlcpcms.actstudio.xyz/'+aboutSingleton.cover_description_3.path"
              class="about-img"
            ></v-img>
          </v-col>
        </v-row>
        <!-- ************/Misión y valores******* -->

        <!-- ***********Nuestro equipo*********** -->
        <v-row class="mb-md-12 mt-2 mt-md-12">
          <v-col cols="12" md="6" class="px-0 py-0 px-md-10" order="1" order-md="0">
            <v-img
              :src="'https://www.mlcpcms.actstudio.xyz/'+aboutSingleton.cover_description_4.path"
              class="about-img"
            ></v-img>
          </v-col>

          <v-col cols="12" md="6" class="px-6 py-4 py-md-0 px-md-10" order="0" order-md="1">
            <span class="title-about bold">{{aboutSingleton.description_4.subtitle}}</span>

            <hr class="d-block hr-about mt-2" />

            <div
              class="mt-2 maxWidth-Three texts"
              id="paragraphs"
              v-html="aboutSingleton.description_4.description"
            ></div>
          </v-col>
        </v-row>
        <!-- ***********/Nuestro equipo********** -->
      </div>
      <!-- section mobile-->

      <!-- ***********Perfil********* -->
      <v-row class="background-blue text-center">
        <v-col cols="12">
          <span class="text-white subtitles">C.P. M.I JORGE ALEJANDRO MARTÍNEZ LOZANO</span>
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="background-blue">
        <v-col cols="auto" class="pa-0 column-width-profile-first">
          <div class="container-dots">
            <div
              class="container-dots__dot-home-us"
              v-for="(profImgDot, pid) in aboutSingleton.profile"
              v-bind:key="pid"
              v-bind:class="{'active-dot' : carouselProfile == pid}"
              @click="carouselProfile = pid"
            ></div>
          </div>
          <v-carousel v-model="carouselProfile" v-bind:show-arrows="false" v-bind:hide-delimiter-background="true" v-bind:hide-delimiters="true" height="100%" cycle interval="5000">
            <v-carousel-item  v-for="(profImg, pi) in aboutSingleton.profile" v-bind:key="pi">
              <v-img
                :src="'https://www.mlcpcms.actstudio.xyz/'+profImg.path"
                class="d-block mr-auto imgPerfil"
              ></v-img>
            </v-carousel-item>
          </v-carousel>
        </v-col>
        <v-col class="position-relative column-width-profile">
          <v-row justify="center" align-content="center">
            <v-col cols="auto">
              <div class="arrow-right-about cursor-pointer" @click="nextSlide()">
                <!-- <v-icon class="icon-arrow-right-videos">mdi-chevron-right</v-icon> -->
                <v-img src="@/assets/png/flecha.png" class="icon-arrow-right-about"></v-img>
              </div>
              <v-sheet color="#37A7DF">
                <v-slide-group
                  max="3"
                  class="slide-about-certificates"
                  v-model="certificateSlider"
                  v-bind:show-arrows="true"
                  v-bind:center-active="true"
                >
                  <v-slide-item v-for="(certificate, cr) in certificates" v-bind:key="cr">
                    <v-card class="card-about background-blue" tile elevation="0">
                      <v-row class="row-height-slide" align="center">
                        <v-col cols="auto">
                          <v-img
                            width="150"
                            class="align-center d-block mx-auto"
                            :src="'https://www.mlcpcms.actstudio.xyz/'+certificate.cover.path"
                          ></v-img>
                        </v-col>
                      </v-row>

                      <v-card-text class="card-text-about">
                        <v-row>
                          <v-col class="text-center">
                            <span
                              class="d-block mt-5 white--text texts"
                              v-for="(content, val) in certificate.description"
                              v-bind:key="val"
                            >{{content.value.description}}</span>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-sheet>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- ***********/Perfil******** -->
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    certificates: [],
    certificateSlider: 0,
    aboutSingleton: {},
    carouselProfile: 0
  }),
  beforeMount: function () {
    //get the about singleton
    fetch(
      "https://www.mlcpcms.actstudio.xyz/api/singletons/get/About?token=16db21f0656450d15b7ee93d559638"
    )
      .then((data) => data.json())
      .then((data) => (this.aboutSingleton = data));

    //get the certificates
    fetch(
      "https://www.mlcpcms.actstudio.xyz/api/collections/get/certificates?token=16db21f0656450d15b7ee93d559638"
    )
      .then((res) => res.json())
      .then((res) => (this.certificates = res.entries));
  },
  mounted: function () {
    this.$emit("update", 1);
  },
  methods: {
    nextSlide: function () {
      this.certificateSlider++;

      if (this.certificateSlider >= this.certificates.length) {
        this.certificateSlider = 0;
      }
    },
    titleSplit: function (val) {
      var value = val.split("Lozano");
      var valueJoin = value.join(" Lozano <br>");
      // console.log(value.join(" y \n"));
      return valueJoin;
    },
  },
};
</script>